import React, { useEffect, useMemo } from 'react';
import { Box, CheckBox, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

import { useFileConvertToLMNStore } from '../../DropScan/stores';

const Overlap = styled(Box)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  opacity: 0.5;
  z-index: 1000;
`;
interface Props {
  index?: number;
  children: React.ReactNode;
  isMultipleMode?: boolean;

  fileId?: string;
}
const SelectFilePage: React.FC<Props> = ({ index = 0, children, fileId, isMultipleMode }) => {
  const isVisible = useFileConvertToLMNStore((state) => state.isApplyMode);
  const selectedIds = useFileConvertToLMNStore((state) => state.selectIndexes);
  const setIsMultipleMode = useFileConvertToLMNStore((state) => state.setIsMultipleMode);
  const setSelectedIds = useFileConvertToLMNStore((state) => state.toggleSelectedIndexes);
  const isSelected = useMemo(() => {
    return selectedIds.includes(index);
  }, [index, selectedIds]);
  useEffect(() => {
    if (isMultipleMode) {
      setIsMultipleMode(true);
    }
    return () => {
      setIsMultipleMode(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMultipleMode]);
  if (isVisible) {
    return (
      <Box direction="row" data-testid="select-file-page-wrapper">
        <Box direction="column" margin={{ right: 'spacing12' }}>
          <Text margin={{ bottom: 'spacing8' }} data-testid="select-file-page-index">
            {index + 1}.
          </Text>
          <CheckBox
            checked={isSelected}
            onChange={() => setSelectedIds(index)}
            data-testid="select-file-page-checkbox"
          />
        </Box>
        <Box style={{ position: 'relative' }} data-testid="select-file-page-content">
          {isSelected && <Overlap background="infoBorder" data-testid="select-file-page-overlay" />}

          {children}
        </Box>
      </Box>
    );
  }
  return children;
};

export default SelectFilePage;
